function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Person Genderless"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  "data-width": 32,
  "data-height": 32,
  className: "iconic-container iconic-person-genderless",
  transform: "scale(1 1 ) translate(0 ) "
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.6 20c-.2 0-.6.2-.8.3-1.8 1.7-4.2 2.7-6.8 2.7s-5-1-6.8-2.7c-.2-.1-.5-.3-.8-.3h-.4c-4.4 0-8 3.6-8 8v3.5c0 .3.2.5.5.5h31c.3 0 .5-.2.5-.5v-3.5c0-4.4-3.6-8-8-8h-.4z",
  className: "iconic-person-body iconic-property-fill"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24 9c0 5.5-2.6 11-8 11-5.5 0-8-5.5-8-11s3.6-9 8-9 8 3.5 8 9z",
  className: "iconic-person-head iconic-property-fill"
}));

function SvgPersonGenderlessMd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-icon": "person-genderless",
    width: 32,
    height: 32,
    className: "iconic iconic-person iconic-size-md iconic-person-genderless",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonGenderlessMd);
export default __webpack_public_path__ + "static/media/person-genderless-md.1fe4f067.svg";
export { ForwardRef as ReactComponent };